<app-modal [open]="open"
           [title]="'Modelos - ' + categoryLabel"
           [width]="720"
           [height]="520"
           (close)="close.emit()">

  <div modalBody class="template-attachments-modal">
    <!-- Área de Upload -->
    <div class="upload-area">
      <input #fileInput type="file"
             accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif"
             (change)="onFileSelected($event)"
             style="display:none">
      <button class="btn btn--yellow"
              (click)="fileInput.click()"
              [disabled]="uploading">
        <i class="fas fa-cloud-upload-alt"></i>
        <span>{{ uploading ? 'Enviando...' : 'Adicionar Modelo' }}</span>
      </button>
      <small>PDF, DOC, DOCX, JPG, PNG, GIF • Max 10 MB</small>
    </div>

    <!-- Lista de Modelos -->
    <div class="templates-list" *ngIf="!loading">
      <div class="template-item" *ngFor="let template of templates">
        <div class="template-info">
          <i [class]="getFileIcon(template.type)"></i>
          <div class="template-details">
            <span class="template-name">{{ template.name }}</span>
            <span class="template-meta">{{ formatSize(template.size) }} • {{ formatDate(template.uploadedAt) }}</span>
          </div>
        </div>
        <div class="template-actions">
          <button class="btn-icon" (click)="downloadTemplate(template)" title="Baixar">
            <i class="fas fa-download"></i>
          </button>
          <button class="btn-icon delete" (click)="deleteTemplate(template)" title="Excluir">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>

      <div class="empty-state" *ngIf="templates.length === 0">
        <i class="fas fa-file-alt"></i>
        <p>Nenhum modelo adicionado ainda</p>
        <small>Adicione modelos de documentos para facilitar o trabalho</small>
      </div>
    </div>

    <div class="loader-state" *ngIf="loading">
      <app-loader></app-loader>
    </div>
  </div>

  <div modalFooter>
    <button class="btn btn--ghost" (click)="close.emit()">
      Fechar
    </button>
  </div>
</app-modal>
